<template>
  <layout-basic>
    <h3 class="title is-4">Projects / {{ project.name }} / test jobs</h3>

    <a class="button is-primary " :href="'/project/' + project._id + '/test-job/new'">
      Add test job
    </a>
    <b-table
      :data="projectTestJobs"
    >
      <b-table-column field="name" label="Name" v-slot="props">
        {{ props.row.name }}
      </b-table-column>

      <b-table-column field="testAlias" label="Test type" v-slot="props">
        <span v-if="props.row.testType">{{props.row.testType.name}}</span>
        <span v-else>-</span>
      </b-table-column>

      <b-table-column field="status" label="Enabled" v-slot="props">
          <span class="tag is-light is-medium" v-bind:class="[props.row.status === 'active' ? 'is-success' : 'is-danger']">
            {{ props.row.status === 'active' ? 'Yes' : 'No' }}
          </span>
      </b-table-column>

      <b-table-column field="timeout" label="Frequency" v-slot="props">
          {{ getFrequency(props.row.timeout) }}
      </b-table-column>

      <b-table-column field="lastRunTime" label="Last execution" v-slot="props">
        <span v-if="!props.row.lastRunTime">-</span>
        <timeago v-else :datetime="props.row.lastRunTime * 1000"></timeago>
      </b-table-column>

      <b-table-column field="totalFailedInRow" label="Status" v-slot="props">
          <span v-if="!props.row.totalFailedInRow">
            <b-tag class="is-light is-medium is-success">Success</b-tag>
          </span>
          <span v-else>
            <b-tag class="is-light is-medium is-danger">{{ props.row.totalFailedInRow|number }} failed in row</b-tag>
          </span>
      </b-table-column>

      <b-table-column field="actions" label="Actions" v-slot="props" class="has-text-right">
        <button class="button is-small is-info" @click="viewTestResults(props.row._id)">
          <b-icon icon="eye" size="is-small"></b-icon>
        </button>

        <a class="button is-small is-info ml-2" :href="'/test-job/' + props.row._id + '/edit'">
          <b-icon icon="pencil-alt" size="is-small"></b-icon>
        </a>

        <button class="button is-small is-danger ml-2" @click="deleteTestJob(props.row._id)">
          <b-icon icon="trash-alt" size="is-small"></b-icon>
        </button>
      </b-table-column>

      <template slot="empty">
        <p>No test jobs created, yet</p>
      </template>
    </b-table>
  </layout-basic>
</template>
<script>

import LayoutBasic from '@/layouts/LayoutBasic'
import TestJobsService from '@/services/TestJobsService'
import ProjectService from '@/services/ProjectService'
import TestResultsListModal from '@/components/TestResults/TestResultsListModal'

export default {
  name: 'ProjectOverview',
  projectId: null,
  components: {
    LayoutBasic
  },
  created() {
    this.getProject()
    this.getTestJobsList()
  },
  data() {
    return {
      projectName: '',
      project: {},
      projectTestJobs: [],
      columns: [
        {field: 'name', label: 'Name'},
        {field: 'testAlias', label: 'Test type'},
        {field: 'testConfig', label: 'Config'},
        {field: 'status', label: 'Status'},
        {field: 'timeout', label: 'Timeout'},
        {field: 'lastRunTime', label: 'Last execution'},
        {field: 'totalFailedInRow', label: 'Total failed in the row'},
      ],
      possibleTests: [
        {
          alias: 'ApiAliveCheckTest',
          name: 'API Monitor',
        }
      ],
      frequencies: [
        {
          name: 'every minute',
          value: 60
        },
        {
          name: 'every 5 minutes',
          value: 300
        },
        {
          name: 'every 10 minutes',
          value: 600
        },
        {
          name: 'every 30 minutes',
          value: 1800
        },
        {
          name: 'hourly',
          value: 3600
        },
        {
          name: 'daily',
          value: 86400
        }
      ]
    }
  },

  methods: {
    cardModal() {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        trapFocus: true,
        width: "1000px",
        props: {
          projectId: this.$route.params.projectId
        }
      })
    },

    getProject() {
      const projectId = this.$route.params.projectId;

      ProjectService.get(projectId).then(response => {
        this.project = response.data;
      })
    },

    getTestNameByAlias(alias) {
      let test = this.possibleTests.find(t => t.alias === alias);

      if (!test) {
        return '-';
      }

      return test.name
    },

    getFrequency(value) {
      let frequency = this.frequencies.find(f => f.value === value);

      if (!frequency) {
        return '-';
      }

      return frequency.name
    },
    deleteTestJob(testJobId) {
      TestJobsService.delete(testJobId).then(response => {
        this.getTestJobsList();
      })
    },

    getTestJobsList() {
      this.projectId = this.$route.params.projectId;
      TestJobsService.getList(this.projectId).then((response) => {
        this.projectTestJobs = response.data;
      }).catch((e) => {
        console.log(e);
      })
    },

    viewTestResults(testJobId) {
      this.$buefy.modal.open({
        parent: this,
        component: TestResultsListModal,
        hasModalCard: true,
        trapFocus: true,
        props: {testJobId}
      })
    }
  }
}
</script>
